import { t } from "i18next";
import React, { useContext } from "react";
import { ContextMobile } from "../../../../HomePage";

// Each option stores a canonical English value (kept in the DB, shown in the
// admin + email) while displaying a translated label to the applicant.
type Option = { key: string; value: string };

const CLOTHING_STYLES: Option[] = [
  { key: "style_sporty", value: "Sporty" },
  { key: "style_casual", value: "Casual" },
  { key: "style_business_casual", value: "Business Casual" },
  { key: "style_dressy", value: "Dressy" },
];

const SHOE_TYPES: Option[] = [
  { key: "shoe_sneakers", value: "Tennis Shoes/Sneakers" },
  { key: "shoe_sandals", value: "Sandals" },
  { key: "shoe_flats", value: "Flats" },
  { key: "shoe_short_heel", value: "Short Heel" },
  { key: "shoe_slippers", value: "Slippers/House Shoes" },
  { key: "shoe_hiking_boots", value: "Hiking Boots" },
  { key: "shoe_work_boots", value: "Work Boots" },
  { key: "shoe_rain_boots", value: "Rain Boots" },
  { key: "shoe_winter_boots", value: "Winter Boots" },
];

const COLORS: Option[] = [
  { key: "color_blue", value: "Blue" },
  { key: "color_black", value: "Black" },
  { key: "color_brown", value: "Brown" },
  { key: "color_gray", value: "Gray" },
  { key: "color_green", value: "Green" },
  { key: "color_orange", value: "Orange" },
  { key: "color_purple", value: "Purple" },
  { key: "color_red", value: "Red" },
  { key: "color_yellow", value: "Yellow" },
];

const ClothingPreferences: React.FC = () => {
  const { handlePeopleChange, people, selectedPersonIndex } =
    useContext<any>(ContextMobile);

  const person = people[selectedPersonIndex];

  const selectedList = (field: string): string[] => {
    const current: string = person[field] || "";
    return current ? current.split(",").filter(Boolean) : [];
  };

  const toggle = (field: string, value: string, checked: boolean) => {
    const list = selectedList(field);
    const next = checked
      ? [...list, value]
      : list.filter((v) => v !== value);
    handlePeopleChange({ [field]: next.join(",") });
  };

  const renderGroup = (label: string, field: string, options: Option[]) => {
    const list = selectedList(field);
    return (
      <div className="sections">
        <div>{label}</div>
        <div className="checkbox-group">
          {options.map((opt) => (
            <label
              className={`checkbox-option${
                list.includes(opt.value) ? " selected" : ""
              }`}
              key={opt.key}
            >
              <input
                type="checkbox"
                className={`check_${opt.key}`}
                checked={list.includes(opt.value)}
                onChange={(e) => toggle(field, opt.value, e.currentTarget.checked)}
              />
              {t(opt.key)}
            </label>
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      {renderGroup(t("clothing_style"), "clothing_styles", CLOTHING_STYLES)}
      {renderGroup(t("shoe_preference"), "shoe_types", SHOE_TYPES)}
      {renderGroup(t("color_preference"), "color_preferences", COLORS)}
    </>
  );
};

export default ClothingPreferences;
